import {TriangularErrorIcon} from '@/assets/icons/icons'
import {Modal} from '@/components/ui/modal/Modal'
import {useMe} from '@/features/authentication/queries/useMe'
import {useRootStore} from '@/store'
import {selectUpdateCreditCardModal} from '@/store/selectors'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {ListOfSupportedUsers} from '../components/list-of-supported-users/ListOfSupportedUsers'
import {
    StyledErrorContainer,
    StyledUpdateCreditCardModalContainer,
    StyledUpdateCreditCardModalDescription
} from './style'

export const UpdateCreditCardModal: FC = () => {
    const {t} = useTranslation()
    const {data: user} = useMe()
    const hasProblemWithPayment = Boolean(user?.profileAlerts?.find(alert => alert.code === 'PA_LEADER_003'))
    const {closeModal} = useRootStore(selectUpdateCreditCardModal)
    return (
        <Modal
            title={t('leader_payments:title')}
            onClose={closeModal}
            minHeight="50vh"
            maxWidth="400px"
            maxHeight="95vh"
        >
            <StyledUpdateCreditCardModalContainer>
                <StyledUpdateCreditCardModalDescription>
                    {t('leader_payments:description')}
                </StyledUpdateCreditCardModalDescription>
                {hasProblemWithPayment && (
                    <StyledErrorContainer>
                        <h3>
                            <TriangularErrorIcon />
                            {t('leader_payments:payment_error:title')}
                        </h3>
                        <span>{t('leader_payments:payment_error:message')}</span>
                    </StyledErrorContainer>
                )}

                <ListOfSupportedUsers />
            </StyledUpdateCreditCardModalContainer>
        </Modal>
    )
}
